
$(function () {
  // Fade Navbar on Scroll down
  $(window).scroll(function () {
    if ($(this).scrollTop() < 25) {
      $('.navbar-brand').fadeIn();
    } else {
      $('.navbar-brand').fadeOut();
    }
  });

  // Toggling visibility for Full Screen Menu
  $('.overlay-menu-button').click(function () {
    $('div#overlay-menu').toggleClass('overlay-menu-hide');
    $('div.overlay-menu-button').toggleClass('change');

    if (!$('div#overlay-menu').hasClass('overlay-menu-hide')) {
      $('.navbar-brand').fadeIn();
    } else {
      if ($(document).scrollTop() > 25) {
        $('.navbar-brand').hide();
      }
    }
  });

});



// WEBPACK FOOTER //
// ./assets/js/menu.js